import { Component, inject, output } from '@angular/core';
import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { ChoiceQuestionTypes, RangeOperators } from '@empathy/survey/base';

import { SurveyConditionalsService } from '../../../../services/survey-conditionals.service';

@Component({
  selector: 'empathy-condition-value-view',
  templateUrl: './condition-value-view.component.html',
  styleUrls: ['./condition-value-view.component.scss']
})
export class ConditionValueViewComponent {
  clearValues = output<number>();

  choiceQuestionTypes = ChoiceQuestionTypes;
  faClose = faClose;
  rangeOperators = RangeOperators;

  surveyConditionalsService = inject(SurveyConditionalsService);
}
